import * as yup from "yup";
import { ListingSortType } from "type/listing-sort";

// Property Type is required in the form, so it is required here (MAX-4403 Q15); until then the field
// carried an asterisk and the embed code appeared without it.
export const listingsSchema = {
	propertyTypeId: yup
		.string()
		.required("Property type is required."),
	cityId: yup
		.string()
		.required("City is required."),
	status: yup
		.string()
		.required("Status is required."),
	sort: yup
		.string()
		.required("Sort is required."),
	resultsPerPage: yup
		.number()
		.required("Results Per Page is required.")
		.typeError("Results Per Page is required.")
		.min(1, "Results Per Page is required.")
		.max(50, "Max 50 results per page"),
};

/** The sort a new Listings widget starts on: List Date (Newest First). */
export const DEFAULT_LISTINGS_SORT = ListingSortType.LISTING_DATE.id;
